import LandingAboutUsCounter from './LandingAboutUsCounter'
import { useTranslation } from 'react-i18next'

const LandingAboutUs = () => {
    const { t } = useTranslation()

    return (
        <div className='bg-bk sm:mt-10 md:mt-10 lg:mt-10 xl:mt-10 text-white p-10'>
            <p className="text-2xl sm:text-3xl md:text-4xl lg:text-4xl xl:text-4xl text-left px-4 sm:px-10 md:px-10 lg:px-10 xl:px-10 mb-10">“{ t('about_quote1') } <span className="text-accent">{ t('about_quote2') }</span>{ t('about_quote3') }</p>
            <div className="flex flex-col md:grid lg:grid xl:grid grid-cols-4 px-4 sm:px-10 md:px-10 lg:px-10 xl:px-10">
                <p className="font-semibold col-start-1 col-end-1 md:px-2">{ t('about') }</p>

                <p className="col-start-2 col-end-5">
                    { t('about_p1_p1') } <span className='font-semibold'> { t('about_p1_h1') }</span>.
                </p>
                <p className="col-start-2 col-end-5 mt-4">
                    { t('about_p2_p1') } <span className='font-semibold'>{ t('about_p2_h1') }</span> { t('about_p2_p2') } <span className='font-semibold'>{ t('about_p2_h2') }</span>.
                </p>
                <p className="col-start-2 col-end-5 mt-4">
                    { t('about_p3_p1') } <span className='font-semibold'>{ t('about_p3_h1') } </span>{ t('about_p3_p2') }.
                </p>
                <p className="col-start-2 col-end-5 mt-8 text-xl">
                    <span className='font-semibold'>{ t('about_p4_h1') }</span>{ t('about_p4_p1') }.
                </p>
                
                

                <div className="col-start-2 col-end-5 flex flex-col sm:flex-row md:flex-row lg:flex-row xl:flex-row justify-between mt-14">
                    <LandingAboutUsCounter years={20} tag={ t('about_i1') }/>
                    <LandingAboutUsCounter years={10} tag={ t('about_i2') }/>
                    <LandingAboutUsCounter years={2000} tag={ t('about_i3') }/>
                </div>
            </div>
        </div>
    )
}

export default LandingAboutUs